import {
  Component,
  Input,
  OnInit,
  AfterViewInit,
  OnDestroy,
  SimpleChanges,
  OnChanges,
  ElementRef,
  ViewChild,
  Output,
  EventEmitter,
} from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

/**
 * 共通部品 多用途コンボボックスを制御するクラス
 *
 * @export VersatileComboBoxComponent
 * @class VersatileComboBoxComponent
 * @implements {OnInit}
 * @implements {AfterViewInit}
 * @implements {OnChanges}
 * @implements {OnDestroy}
 * @implements {ControlValueAccessor}
 */
@Component({
  selector: 'app-versatile-combo-box',
  templateUrl: 'versatile-combo-box.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: VersatileComboBoxComponent,
      multi: true,
    },
  ],
})
export class VersatileComboBoxComponent
  implements OnInit, AfterViewInit, OnChanges, OnDestroy, ControlValueAccessor
{
  @ViewChild('comboBox', { static: true }) public comboBox: ElementRef;

  @Input() public subid: string = null;
  @Input() blank: boolean = false; // 空白許容フラグ
  @Input() blankVal = ''; // 空白コード値
  @Input() disabled: boolean = <boolean>false;
  @Input() required: boolean = <boolean>false;
  @Input() width: number = null;
  @Input() height: number = null;
  @Input() valueField = 'Code'; // コード値属性名
  @Input() labelField = 'Name'; // ラベル属性名
  @Input() public tabindex: number = null;
  @Input() visible: boolean = <boolean>true; // 表示・非表示フラグ
  @Input() autofocus: boolean = <boolean>false; // 初期フォーカスフラグ
  @Input() forcedEnabledMode: string = null;
  @Input() listSource: Array<unknown> = [];
  @Input() dspBothField = false; // 001:ラベル 形式のフラグ

  @Output() onError = new EventEmitter(); //
  @Output() onChangedInvalid = new EventEmitter();

  public selectedCodeValue = '';
  private static readonly LABEL_DELIMITER = ':';

  /**
   * Creates an instance of codeComboBox.
   * @memberof codeComboBox
   */
  constructor(public elementRef: ElementRef) {}

  // ValueAccessor
  public onChange(_: any) {}
  public onTouched() {}
  public writeValue(text: string): void {
    if (!text) {
      this.selectedCodeValue = '';
      return;
    }
    const check = this.listSource?.find(
      _ =>
        _ instanceof Object &&
        this.labelField in _ &&
        this.valueField in _ &&
        text === _[this.valueField]
    );
    if (!check) this.onChangedInvalid.emit();
    this.selectedCodeValue = text;
  }
  public registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  public registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  public setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  /**
   * 初期化処理
   *
   * @memberof VersatileComboBoxComponent
   */
  ngOnInit(): void {
    // コンボボックスインスタンス設定
    this.comboBox.nativeElement.setAttribute('id', this.subid + '_sub');
    this.comboBox.nativeElement.setAttribute(
      'forcedEnabledMode',
      this.forcedEnabledMode
    );
  }

  /**
   * ロード完了時
   *
   * @memberof VersatileComboBoxComponent
   */
  ngAfterViewInit(): void {
    const check = this.listSource?.every(
      _ => _ instanceof Object && this.labelField in _ && this.valueField in _
    );
    if (!check) {
      this.onError.emit();
    }
  }

  /**
   * 値変更時イベント
   *
   * @param {SimpleChanges} changes 変更イベント
   * @memberof VersatileComboBoxComponent
   */
  ngOnChanges(changes: SimpleChanges): void {}

  /**
   * コンポーネント終了時
   *
   * @memberof VersatileComboBoxComponent
   */
  ngOnDestroy(): void {}
}
